import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	emptyStateHeader: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	emptyStateDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	emptySearchHeader: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	emptyStateHeader: {
		defaultMessage: "You don't have any boards, yet",
		id: 'home.tabs.boards.empty-state.empty-state-header',
		description: 'Empty State heading for Boards tab in Jira Home',
	},
	emptyStateDescription: {
		defaultMessage: 'Create a board to start tracking your work',
		id: 'home.tabs.boards.empty-state.empty-state-description',
		description: 'Empty State description for Boards tab in Jira Home',
	},
	emptySearchHeader: {
		defaultMessage: 'We couldn’t find anything matching your search.',
		id: 'home.tabs.boards.empty-state.empty-search-header',
		description: 'Empty Search state heading for Boards tab in Jira Home',
	},
});
export default messages;
